/*@ngInject*/
const UMDropdownKeyboardControlsDirective = function ($rootScope, $document, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;

        function onKeyDown(event) {
            switch (event.keyCode) {
                case 9:
                    handleTabKey(event);
                    break;

                case 13:
                    handleEnterKey(event);
                    break;

                case 27:
                    handleEscapeKey(event);
                    break;

                case 38:
                    handleUpKey(event);
                    break;

                case 40:
                    handleDownKey(event);
                    break;

                default:
                    break;
            }
        }

        function handleTabKey(event) {
            // Ignore the default TAB behavior and handle it ourselves
            event.preventDefault();

            const backwards = event.shiftKey;
            const clearSearchInputButton = $('.umPopover um-dropdown-search .clearSearchButton');
            const clearSelectedButton = $('.umPopover um-label-button .labelButton:enabled');

            switch (currentDropdownSearchInterface) {
                case coreConstant.dropdown.searchInterface.SEARCH_INPUT:
                    if (backwards) {
                        focusClearSelectedButton(event, clearSelectedButton);
                    } else {
                        focusClearSearchInputButton(event, clearSearchInputButton);
                    }

                    break;

                case coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON:
                    if (backwards) {
                        focusSearchInput();
                    } else {
                        focusClearSelectedButton(event, clearSelectedButton);
                    }

                    break;

                case coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON:
                    if (backwards) {
                        focusClearSearchInputButton(event, clearSearchInputButton);
                    } else {
                        focusSearchInput();
                    }

                    break;

                default:
                    break;
            }
        }

        function focusSearchInput() {
            currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
            $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON);
            $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON);
        }

        function focusClearSelectedButton(event, clearSelectedButton) {
            currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON;

            if (clearSelectedButton.length !== 0) {
                $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SELECTED_BUTTON);
                $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SEARCH_INPUT_BUTTON);
            } else {
                handleTabKey(event);
            }
        }

        function focusClearSearchInputButton(event, clearSearchInputButton) {
            currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON;

            if (clearSearchInputButton.length !== 0) {
                $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SEARCH_INPUT_BUTTON);
                $rootScope.$broadcast(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON);
            } else {
                handleTabKey(event);
            }
        }

        function handleUpKey(event) {
            // Ignore the default behavior to prevent the cursor from moving around in the search input
            event.preventDefault();

            focusSearchInput();

            $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_UP);
        }

        function handleDownKey(event) {
            // Ignore the default behavior to prevent the cursor from moving around in the search input
            event.preventDefault();

            focusSearchInput();

            $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_HIGHLIGHT_DOWN);
        }

        function handleEnterKey(event) {
            event.preventDefault();

            switch (currentDropdownSearchInterface) {
                case coreConstant.dropdown.searchInterface.SEARCH_INPUT:
                    $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_SELECT_HIGHLIGHTED_ITEM);
                    break;

                case coreConstant.dropdown.searchInterface.CLEAR_SEARCH_INPUT_BUTTON:
                    currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
                    $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLEAR_SEARCH_INPUT);
                    break;

                case coreConstant.dropdown.searchInterface.CLEAR_SELECTED_BUTTON:
                    currentDropdownSearchInterface = coreConstant.dropdown.searchInterface.SEARCH_INPUT;
                    $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED);
                    break;

                default:
                    break;
            }
        }

        function handleEscapeKey(event) {
            event.preventDefault();

            $rootScope.$broadcast(coreConstant.event.dropdown.DROPDOWN_CLOSE);
        }

        $document.bind('keydown.umDropdownKeyboardControls', onKeyDown);

        $scope.$on('$destroy', function () {
            $document.unbind('keydown.umDropdownKeyboardControls', onKeyDown);
        });
    };

    return {
        link: linkFunction,
        restrict: 'E'
    };
};

angular.module('umCore')
    .directive('umDropdownKeyboardControls', UMDropdownKeyboardControlsDirective);
